import React, { useState, useEffect } from "react";
import classes from './Settings.module.css';
import HeaderNav from '../../Components/Dahboard Header/HeaderNav/HeaderNav';
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import searchicon from "../../Assets/searchicon.png";
import filter from "../../Assets/filter.png";
import axios from "axios";
import Footer from "../../Components/Footer/Footer";




const SupplierPayables = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const token = localStorage.getItem("authToken");



    const allSelected = selectedRows.length === data.length;

    const handleSelectAll = () => {
        if (allSelected) {
            setSelectedRows([]);
        } else {
            setSelectedRows(data.map((_, index) => index));
        }
    };


    const pageMap = {
        '/dashboard': 'Dashboard',
        '/transactions': 'Transactions',
        '/accounts': 'Accounting',
        '/reports': 'Reports',
        '/banking': 'Banking',
        '/settings': 'Settings',
    };



    useEffect(() => {
        fetchStocks();
    }, []);

    const fetchStocks = async () => {
        try {
            const res = await axios.get(
                "https://api-sme.promixaccounting.com/api/v1/fetch_stocks",
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        Accept: "application/json",
                    },
                }
            );

            // Check the structure of API response
            if (res.data?.data) {
                setData(res.data.data);
            } else {
                console.error("Unexpected API response", res.data);
            }
        } catch (error) {
            console.error("Error fetching stocks:", error);
        }
    };

    const handleSelectRow = (i) => {
        setSelectedRows((prev) =>
            prev.includes(i) ? prev.filter((row) => row !== i) : [...prev, i]
        );
    };

    const renderType = (type) => <span>{type}</span>;

    const formatCurrency = (amount) => {
        if (!amount && amount !== 0) return "";
        return `₦${Number(amount).toLocaleString("en-NG", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        })}`;
    };

    return (
        <div>
            <HeaderNav activePage={pageMap[location.pathname]} />

            <div className={classes.Container}>
                <div className={classes.actions}>
                    <button className={classes.btns}>New Sales Invoice</button>
                    <button className={classes.btns}>New Purchase Invoice</button>
                    <button className={classes.btns}>All Invoices</button>
                    <button className={`${classes.btnss} ${classes.greens}`}>Product & Services </button>
                </div>

                <header className={classes.Header}>
                    <h2 className={classes.Title}>Supplier Payables</h2>
                    <h1 className={classes.Titles}>
                        Manage your Supplier Payables.
                    </h1>
                </header>

                <div className={classes.entrjj}>
                    <div className={classes.allkads}>
                        <div className={classes.thrdkad}>
                            <div className={classes.kad}>
                                <p className={classes.kdptg}>4</p>
                                <div className={classes.rvnue}>
                                    <p className={classes.skaltxt}>Total Receipt</p>
                                </div>
                            </div>
                        </div>
                        <div className={classes.frtkad}>
                            <div className={classes.kad}>
                                <p className={classes.kdptg}>2</p>
                                <div className={classes.rvnue}>
                                    <p className={classes.skaltxt}>Products</p>
                                </div>
                            </div>
                        </div>
                        <div className={classes.fiftkad}>
                            <div className={classes.kad}>
                                <p className={classes.kdptg}>2</p>
                                <div className={classes.rvnue}>
                                    <p className={classes.skaltxt}>Services</p>
                                </div>
                            </div>
                        </div>
                        <div className={classes.frstkad}>
                            <div className={classes.kad}>
                                <p className={classes.kdptg}>4</p>
                                <div className={classes.rvnue}>
                                    <p className={classes.skaltxt}>Total Outstanding</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className={classes.headerActions}>
                    <p className={classes.actionsLeft}>{selectedRows.length} selected</p>
                    <div className={classes.actionsRight}>
                        <div className={classes.inputWrapper}>
                            <input type="text" className={classes.searchBar} placeholder="Search..." />
                            <img src={searchicon} alt="Search" className={classes.inputIconGreen} />
                        </div>
                        <div className={classes.inputWrapper}>
                            <input type="text" className={classes.searchBar} placeholder="Filter..." />
                            <img src={filter} alt="Filter" className={classes.inputIcon} />
                        </div>
                        <button className={classes.btnss} onClick={() => navigate("/inventory/supplier_payables/new-payables")}> +  New items</button>
                    </div>
                </div>

                <div className={classes.tableContainer}>
                    <table className={classes.table}>
                        <thead>
                            <tr>
                                <th>
                                    <input
                                        type="checkbox"
                                        checked={allSelected}
                                        onChange={handleSelectAll}
                                    />
                                </th>
                                <th>Transaction Date</th>
                                <th>Supplier's Name</th>
                                <th>Description of Payment</th>
                                <th>Amount</th>
                                <th>Receipt Number</th>
                                <th>Status</th>
                                <th>Post Date</th>
                                {/* <th>Stock</th> */}
                                <th>Action</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.map((item, i) => (
                                <tr key={i}>
                                    <td>
                                        <input
                                            type="checkbox"
                                            checked={selectedRows.includes(i)}
                                            onChange={() => handleSelectRow(i)}
                                        />
                                    </td>
                                    <td>{item.stock_id}</td>
                                    <td>{item.name}</td>
                                    <td>{item.description}</td>
                                    {/* <td>{item.category?.name}</td> */}
                                    <td>{renderType(i % 2 === 0 ? "Service" : "Product")}</td>
                                    <td style={{ textAlign: "right" }}>{formatCurrency(item.unit_price)}</td>
                                    <td style={{ textAlign: "right" }}>{formatCurrency(item.unit_price)}</td>
                                    <td style={{ textAlign: "right" }}>{item.quantity}</td>
                                    <td>
                                        <span className={classes.activeStatus}>Active</span>
                                    </td>
                                    <td>⋮</td>
                                </tr>
                            ))}
                        </tbody>

                    </table>
                </div>

                <table className={classes.footerTable}>
                    <tfoot>
                        <tr>
                            <td>First</td>
                            <td className={`${classes.page} ${classes.activePage}`}>1</td>
                            <td className={classes.page}>2</td>
                            <td>Last</td>
                        </tr>
                    </tfoot>
                </table>

                <div className={classes.paginationDisplay}>Displaying 1 - 25 of 41</div>
            </div>
            <Footer />
        </div>
    );
};

export default SupplierPayables
